
export class WidgetSort {
colId: string;
sort: string;
sortIndex: number;
}

